/* eslint-disable react/prop-types */
import React from 'react';
import { Form } from 'react-bootstrap5';

import Flatpickr from 'react-flatpickr';

import {
  ErrorMessage,
  useField,
} from 'formik';

export default function HorizontalDateField(props) {
  const {
    name, label, hint, required, onChange,
  } = props;

  const [field, meta, helpers] = useField(props);
  const { setValue } = helpers;

  const errorClass = meta.error !== undefined && meta.touched ? 'is-invalid' : '';

  const onDateChange = ([date]) => {
    setValue(date);
    if (onChange !== undefined) {
      onChange(date);
    }
  };

  return (
    <Form.Group className="mb-3" controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <Flatpickr
        className={`form-control ${errorClass}`}
        options={{ dateFormat: 'm/d/Y', allowInput: true, static: true }}
        onChange={onDateChange}
        value={field.value}
      />
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}
